"use client";

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";
import type { ProjectCardData } from "./types";

export function ProjectActions({
  project,
  select,
  manage,
  archive,
  isSelecting,
}: {
  project: Pick<ProjectCardData, "id" | "title" | "status">;
  select: () => void;
  manage: () => void;
  archive: () => void;
  isSelecting: boolean;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Project actions for ${project.title}`}
          aria-haspopup="menu"
          disabled={isSelecting}
          aria-busy={isSelecting}
          className={cn(
            "pointer-events-auto shrink-0 -m-2.5 p-2.5 sm:m-0 sm:p-0 text-contrast/40 hover:text-contrast/70 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary rounded-md sm:rounded",
            isSelecting ? "cursor-wait opacity-70" : "cursor-pointer",
          )}
        >
          <Icon name="IconDotGrid1x3Horizontal" size={20} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" collisionPadding={8} className="min-w-[180px]">
        <DropdownMenuItem onSelect={select} disabled={isSelecting} className="min-w-[168px]">
          <Icon
            name="IconSubscriptionTick1"
            size={16}
            className={cn("text-heading shrink-0", isSelecting ? "opacity-30" : "opacity-40")}
          />
          Select Project
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={manage}>
          <Icon name="IconSettingsGear2" size={16} className="text-heading opacity-40" />
          Manage Project
        </DropdownMenuItem>
        {project.status !== "Archived" ? (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem variant="destructive" onSelect={archive}>
              <Icon name="IconTrashCanSimple" size={16} />
              Archive Project
            </DropdownMenuItem>
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
